<template>
  <section :class="['trusted_by_section', sectionClass]" v-if="brand_list.length">
            <div class="container">
                <div class="trusted_by_box">
                <div class="section_heading_box">
                    <h2 class="trusted_by_title section_heading "><span class="bg_secondary_white px_40">Trusted By</span></h2>

                </div>
                    
                    <div class="owl-carousel trusted_by_slider" v-if="brand_list.length">
                        <div
                            class="item trusted_by_slide_item"
                            v-for="(brandGroup, groupIndex) in brand_list"
                            :key="'trusted-by-group-' + groupIndex"
                        >
                            <div class="trusted_by_logo_strip">
                                <div
                                    class="trusted_by_logo_item"
                                    v-for="(brand, index) in brandGroup"
                                    :key="'trusted-by-brand-' + (brand.id || index)"
                                >
                                    <img
                                        :src="brand.logo_image"
                                        :alt="brand.name ? brand.name : 'brand_logo'"
                                        class="trusted_by_logo_img"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="trusted_by_dots_custom" v-if="brand_list.length">
                        <span
                            v-for="dot in trustedByWindowDots"
                            :key="'trusted-by-window-dot-' + dot.role"
                            class="trusted_by_dot"
                            :class="{
                                'trusted_by_dot--active': dot.active,
                                'trusted_by_dot--disabled': dot.disabled
                            }"
                            @click="onTrustedByWindowDotClick(dot)"
                        ></span>
                    </div>
                    <div class="trusted_by_logo_strip trusted_by_logo_strip--placeholder" v-else>
                        <div class="trusted_by_logo_item" v-for="n in 6" :key="'trusted-by-placeholder-' + n"></div>
                    </div>
                </div>
            </div>
        </section>
</template>

<script>
export default {
    name: "TrustedBySection",
    props: {
        logos: {
            type: Array,
            default: () => []
        },
        sectionClass: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            trustedByActiveIndex: 0,
            trustedByTotalSlides: 0
        };
    },
    computed: {
        brand_list() {
            const normalizedLogos = (this.logos || []).filter((x) => x && x.logo_image);
            const chunkSize = 6;
            const chunks = [];
            for (let i = 0; i < normalizedLogos.length; i += chunkSize) {
                chunks.push(normalizedLogos.slice(i, i + chunkSize));
            }
            return chunks;
        },
        trustedByWindowDots() {
            const total = this.trustedByTotalSlides || this.brand_list.length || 0;
            const current = Math.max(
                0,
                Math.min(this.trustedByActiveIndex, Math.max(total - 1, 0))
            );
            if (!total) return [];
            const prevIndex = current > 0 ? current - 1 : total - 1;
            const nextIndex = current < total - 1 ? current + 1 : 0;
            return [
                {
                    role: "prev",
                    targetIndex: prevIndex,
                    active: false,
                    disabled: total <= 1
                },
                {
                    role: "current",
                    targetIndex: current,
                    active: true,
                    disabled: true
                },
                {
                    role: "next",
                    targetIndex: nextIndex,
                    active: false,
                    disabled: total <= 1
                }
            ];
        }
    },
    watch: {
        brand_list() {
            this.$nextTick(() => {
                this.initTrustedBySlider();
            });
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initTrustedBySlider();
        });
    },
    beforeDestroy() {
        if (typeof $ !== "undefined") {
            const $trustedBySlider = $(this.$el).find(".trusted_by_slider");
            if ($trustedBySlider.length > 0) {
                $trustedBySlider.trigger("destroy.owl.carousel");
                $trustedBySlider.off("initialized.owl.carousel changed.owl.carousel");
            }
        }
    },
    methods: {
        onTrustedByWindowDotClick(dot) {
            if (!dot || dot.disabled || dot.targetIndex == null) return;
            if (typeof $ !== "undefined") {
                const $trustedBySlider = $(this.$el).find(".trusted_by_slider");
                if ($trustedBySlider.length > 0) {
                    $trustedBySlider.trigger("to.owl.carousel", [dot.targetIndex, 250]);
                }
            }
        },
        initTrustedBySlider() {
            if (typeof $ === "undefined" || !$.fn || !$.fn.owlCarousel) return;
            const _this = this;
            const $trustedBySlider = $(this.$el).find(".trusted_by_slider");
            if ($trustedBySlider.length === 0) return;

            if ($trustedBySlider.data("owl.carousel")) {
                $trustedBySlider.trigger("destroy.owl.carousel");
                $trustedBySlider.off("initialized.owl.carousel changed.owl.carousel");
            }

            $trustedBySlider.on(
                "initialized.owl.carousel changed.owl.carousel",
                function (event) {
                    const pageInfo = event && event.page ? event.page : null;
                    _this.trustedByActiveIndex = pageInfo ? pageInfo.index : 0;
                    _this.trustedByTotalSlides = pageInfo
                        ? pageInfo.count
                        : _this.brand_list.length;
                }
            );

            $trustedBySlider.owlCarousel({
                loop: true,
                margin: 0,
                nav: false,
                dots: true,
                items: 1,
                slideBy: 1,
                autoplay: true,
                autoplayTimeout: 7000,
                autoplayHoverPause: false
            });
        }
    }
};
</script>

<style scoped>
    .trusted_by_section{
        background-color: #E8F0F8;
    }
.trusted_by_section.no-bg  {
    background: none !important;
}
.trusted_by_section.no-bg .trusted_by_box .trusted_by_logo_strip{
    background: none !important;
}
.trusted_by_section {
    padding: 0px !important;
}

.trusted_by_section .trusted_by_box {
    border: none;
    padding: 40px;
    position: relative;
   
}
.trusted_by_section .trusted_by_box .section_heading_box{
   margin-top: 0px;
}
.trusted_by_section.home-trusted-by .trusted_by_box .trusted_by_title span{
    background-color: #E8F0F8;
}
.trusted_by_section .trusted_by_box .trusted_by_title span{
    background-color: #fff;
}
.trusted_by_section .trusted_by_title {
    font-size: 46px;
    line-height: 46px;
    font-weight: 500;
    color: #2B2B2B;
    text-align: center;
    margin-bottom: 32px;
    position: relative;

}

.trusted_by_section .trusted_by_title span{
    position: relative;
    z-index: 1;
}

.trusted_by_section .trusted_by_logo_strip {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    border: 1px solid #BEBEBE99;
    
}

.trusted_by_section .trusted_by_logo_item {
    min-height: 120px;
    border-right: 1px solid #BEBEBE99;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 12px;
}

.trusted_by_section .trusted_by_logo_item:last-child {
    border-right: none;
}

.trusted_by_section .trusted_by_logo_item a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.trusted_by_section .trusted_by_logo_img {
    max-width: 160px;
    max-height: 100px;
    width: 100%;
    object-fit: contain;
}

.trusted_by_section .trusted_by_logo_strip--placeholder .trusted_by_logo_item {
    background: #fff;
}

.trusted_by_section .trusted_by_slider {
    padding: 0;
}

/* Owl injects `.owl-stage-outer` without Vue scope attributes — :deep applies here */
.trusted_by_section .trusted_by_slider ::v-deep .owl-stage-outer {
    overflow: hidden !important;
}

.trusted_by_section .trusted_by_slider .trusted_by_slide_item {
    padding: 0;
}

.trusted_by_section .trusted_by_slider .owl-dots {
    display: none !important;
}

.trusted_by_section .trusted_by_dots_custom {
    margin-top: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    line-height: 0;
}

.trusted_by_section .trusted_by_dots_custom .trusted_by_dot {
    width: 12px;
    height: 12px;
    border-radius: 100%;
    background: #929292;
    display: block;
    cursor: pointer;
}

.trusted_by_section .trusted_by_dots_custom .trusted_by_dot--active {
    background: #F2790C;
    cursor: default;
    animation: trustedByDotBlink 1s ease-in-out infinite;
}

.trusted_by_section .trusted_by_dots_custom .trusted_by_dot--disabled {
    opacity: 0.5;
}

@keyframes trustedByDotBlink {
    0%,
    100% {
        opacity: 1;
    }
    50% {
        opacity: 0.45;
    }
}
@media (max-width: 1199px) {
    .trusted_by_section .trusted_by_title {
        font-size: 32px;
    }

    .trusted_by_section .trusted_by_logo_strip {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .trusted_by_section .trusted_by_logo_item:nth-child(3n) {
        border-right: none;
    }
}

@media (max-width: 767.98px) {

    .trusted_by_section .trusted_by_box {
        padding: 20px;
    }

    .trusted_by_section .trusted_by_title {
        font-size: 26px;
        margin-bottom: 12px;
    }

    .trusted_by_section .trusted_by_logo_strip {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .trusted_by_section .trusted_by_logo_item {
        min-height: 52px;
        border-right: 1px solid #e1e6ed;
    }

    .trusted_by_section .trusted_by_logo_item:nth-child(2n) {
        border-right: none;
    }
}
</style>
